<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="'Results: ' + survey.title"
        [back]="true"
        [backRoute]="routeToRedirectTo"
        [menuService]="tabMenuService"
    >
        <div class="header-content margin-top-2 margin-left-1">
            <ui-info [text]="surveyResultsTitleTooltip | appTranslate"></ui-info>
        </div>
        <div class="buttons">
            <ui-button type="primary" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('csv')">{{ 'export-as-csv' | translate }}</button>
                <button mat-menu-item (click)="onExport('xlxs')">{{ 'export-as-xlsx' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>

    <div class="report-body" *ngIf="reportLoaded && report; else emptyState">
        <app-report-table [report]="report"></app-report-table>
    </div>
</div>

<ng-template #emptyState>
    <div class="ui segment">
        <app-empty-state label="There is no survey data to report on."></app-empty-state>
    </div>
</ng-template>
